// src/data/courseData.js
export const courseDetails = {
  "data-structures": {
    id: "data-structures",
    title: "Data Structures and Algorithms",
    duration: "8–10 weeks",
    modules: [
      {
        name: "Foundations",
        topics: ["Arrays", "Linked Lists", "Stacks", "Queues"]
      },
      {
        name: "Advanced Structures",
        topics: ["Trees", "Graphs", "Hash Tables", "Heaps"]
      },
      {
        name: "Algorithms",
        topics: ["Sorting", "Searching", "Dynamic Programming", "Greedy Algorithms"]
      }
    ]
  },

  "apache-spark": {
    id: "apache-spark",
    title: "Big Data Processing with Apache Spark",
    duration: "6–8 weeks",
    modules: [
      {
        name: "Introduction to Spark",
        topics: ["RDDs", "DataFrames", "Spark SQL"]
      },
      {
        name: "Advanced Spark",
        topics: ["Spark Streaming", "Machine Learning with Spark MLlib"]
      }
    ]
  },

  "cloud-architect": {
    id: "cloud-architect",
    title: "Cloud Architect Masterclass",
    duration: "5 months",
    modules: [
      {
        name: "Cloud Foundations",
        topics: ["Cloud Models", "Virtualization", "IAM"]
      },
      {
        name: "AWS Architecture",
        topics: ["EC2", "S3", "VPC", "Load Balancers", "Auto Scaling"]
      },
      {
        name: "DevOps & Monitoring",
        topics: ["CI/CD", "CloudWatch", "CloudTrail"]
      }
    ]
  },

  "full-stack-java": {
    id: "full-stack-java",
    title: "Full Stack JAVA",
    duration: "5 months",
    modules: [
      {
        name: "Cloud Foundations",
        topics: ["Cloud Models", "Virtualization", "IAM"]
      },
      {
        name: "AWS Architecture",
        topics: ["EC2", "S3", "VPC", "Load Balancers", "Auto Scaling"]
      },
      {
        name: "DevOps & Monitoring",
        topics: ["CI/CD", "CloudWatch", "CloudTrail"]
      }
    ]
  }
};
